/**
 * Spacing utility styles for margins and padding.
 */
import * as stylex from "@stylexjs/stylex";

import { space } from "../tokens.stylex";

export const spacing = stylex.create({
  mt1: { marginTop: space.xs },
  mt2: { marginTop: space.sm },
  mt4: { marginTop: space.md },
  mt6: { marginTop: space.lg },
  mt8: { marginTop: space["2xl"] },
  mb1: { marginBottom: space.xs },
  mb2: { marginBottom: space.sm },
  mb4: { marginBottom: space.md },
  mb6: { marginBottom: space.lg },
  mb8: { marginBottom: space["2xl"] },
  ml2: { marginLeft: space.sm },
  pt4: { paddingTop: space.md },
  py2: { paddingBlock: space.sm },
  py3: { paddingBlock: space.md },
  py8: { paddingBlock: space["2xl"] },
  px2: { paddingInline: space.sm },
  px3: { paddingInline: space.md },
  px4: { paddingInline: space.md },
  p3: { padding: space.md },
  p4: { padding: space.md },
  p6: { padding: space.lg },
  p8: { padding: space["2xl"] },
});
